/*
  TREASURE BOX - 언어별 참고 통화 환산 표시 (Currency Display Converter)
  ------------------------------------------------------------------
  ⚠️ 표시 전용(참고용) 기능입니다. 실제 결제/장바구니/체크아웃 금액은
  Shopify 설정에 따라 항상 원화(KRW)로 처리되며, 이 스크립트는 그 금액을
  변경하지 않습니다. 오직 화면에 보이는 가격 옆에 "약 ¥000 / 약 $00.00"
  형태의 참고 환산가를 추가로 표시할 뿐입니다.

  동작 방식:
  - 페이지의 <html lang="..."> 값을 확인합니다.
    - lang="ja" (일본어) → 엔화(JPY) 참고가 표시
    - lang="en" (영어)   → 미국달러(USD) 참고가 표시
    - 그 외(ko 등)       → 변환 없음 (원화 그대로)
  - 실시간 환율은 무료 공개 API(open.er-api.com, KRW 기준)에서 가져오며,
    브라우저 localStorage에 6시간 캐시하여 API 호출을 최소화합니다.
  - API 호출이 실패하면 대략적인 고정 환율(FALLBACK_RATES)로 대체합니다.
  - 장바구니 드로어, 빠른 보기 등 AJAX로 새로 추가되는 가격 요소도
    MutationObserver로 감지하여 자동으로 환산가를 추가합니다.
*/
window.TBFXConverter = (function () {
  var CURRENCY_MAP = {
    ja: { code: 'JPY', symbol: '¥', decimals: 0 },
    en: { code: 'USD', symbol: '$', decimals: 2 },
  };

  // API 실패 시 사용할 대략적인 고정 환율 (1원당 환산 비율, 참고용)
  var FALLBACK_RATES = { JPY: 0.115, USD: 0.00074 };

  var CACHE_KEY = 'tb_fx_rate_cache_v1';
  var CACHE_TTL = 6 * 60 * 60 * 1000; // 6시간

  // 가격 요소로 인식할 셀렉터 목록 (Dawn 테마 + TREASURE BOX 커스텀 마크업 기준)
  var SELECTORS = [
    '.price-item',
    '.totals__total-value',
    '.cart-item__old-price',
    '.cart-item__final-price',
    '.price--end',
    '.tb-price-original',
    '.tb-price-current',
  ].join(',');

  // "₩50,000 KRW" (money_with_currency) 와 "₩50,000" (money) 두 형태를 모두 인식
  var KRW_PATTERN = /₩\s?([\d,]+)\s?(?:KRW)?/;

  var observer = null;

  function getCachedRate() {
    try {
      var raw = window.localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.timestamp || !data.rates) return null;
      if (Date.now() - data.timestamp > CACHE_TTL) return null;
      return data.rates;
    } catch (e) {
      return null;
    }
  }

  function setCachedRate(rates) {
    try {
      window.localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ timestamp: Date.now(), rates: rates })
      );
    } catch (e) {
      /* localStorage 사용 불가 환경 - 무시 */
    }
  }

  function fetchRate(callback) {
    var cached = getCachedRate();
    if (cached) {
      callback(cached);
      return;
    }
    fetch('https://open.er-api.com/v6/latest/KRW')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.result === 'success' && data.rates) {
          var rates = { JPY: data.rates.JPY, USD: data.rates.USD };
          setCachedRate(rates);
          callback(rates);
        } else {
          callback(FALLBACK_RATES);
        }
      })
      .catch(function () {
        callback(FALLBACK_RATES);
      });
  }

  function formatConverted(krwAmount, rate, target) {
    var converted = krwAmount * rate;
    if (target.decimals === 0) {
      converted = Math.round(converted);
      return target.symbol + converted.toLocaleString('en-US');
    }
    return (
      target.symbol +
      converted.toLocaleString('en-US', {
        minimumFractionDigits: target.decimals,
        maximumFractionDigits: target.decimals,
      })
    );
  }

  function clearPrevious() {
    var olds = document.querySelectorAll('.tb-fx-approx');
    olds.forEach(function (el) {
      el.remove();
    });
    var done = document.querySelectorAll('[data-tb-fx-done]');
    done.forEach(function (el) {
      el.removeAttribute('data-tb-fx-done');
    });
  }

  function convertNode(node, rate, target) {
    if (!node || node.nodeType !== 1) return;
    if (node.dataset && node.dataset.tbFxDone === '1') return;
    if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;

    if (node.children.length === 0) {
      var text = node.textContent;
      var match = text && text.match(KRW_PATTERN);
      if (match) {
        var amount = parseInt(match[1].replace(/,/g, ''), 10);
        if (!isNaN(amount)) {
          var suffix = document.createElement('span');
          suffix.className = 'tb-fx-approx';
          suffix.textContent = ' (\u2248 ' + formatConverted(amount, rate, target) + ')';
          node.appendChild(suffix);
          node.dataset.tbFxDone = '1';
        }
      }
      return;
    }

    for (var i = 0; i < node.children.length; i++) {
      convertNode(node.children[i], rate, target);
    }
  }

  function runConversion(rate, target) {
    var nodes = document.querySelectorAll(SELECTORS);
    nodes.forEach(function (n) {
      convertNode(n, rate, target);
    });
  }

  function init() {
    var lang = document.documentElement.lang || 'ko';
    var target = CURRENCY_MAP[lang];

    // 이전 실행 결과(다른 언어로의 환산 표시 등)를 먼저 정리
    clearPrevious();
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (!target) return; // 한국어 등: 변환 없음, 원화 그대로 표시

    fetchRate(function (rates) {
      var rateValue = rates[target.code];
      if (!rateValue) return;

      runConversion(rateValue, target);

      observer = new MutationObserver(function () {
        runConversion(rateValue, target);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  return { init: init };
})();

document.addEventListener('DOMContentLoaded', function () {
  window.TBFXConverter.init();
});
